import styles from './CustomBonusTable.module.scss';
import { IApplicationState, OVERLAY_ALL_CLOSE, OVERLAY_CMS_PAGE_SHOW } from '@spinwise/spinwise-core';
import { useDispatch, useSelector } from 'react-redux';
import { BaseText, EBaseTextSize, EBaseTextWeight } from '@spinwise/react-component-library/BaseText';
import { EBrandTextColor, TypographyLibrary } from 'Libraries/typography.library';
import { EOverlayContentWidth, POSITIONS } from 'Components/shared/Overlay/elements/OverlayFixedBg/types';
import PromoTableItem from 'Components/blocks/Bonuses/PromoBonus/PromoGridTable/item/PromoTableItem';
import classNames from 'classnames';
import BrandIcon, {
  BonusIconMap,
  BrandIconsSizes,
  ShapeColors,
  StatusIcons,
} from 'Components/shared/BrandIcon/BrandIcon';
import { t } from 'i18next';
import { ButtonLibrary } from 'Libraries/buttons.library';
import router from 'next/router';
import { EComponentVisibility } from '@spinwise/react-component-library/Global';
import { ButtonTextOnly } from '@spinwise/react-component-library/ButtonTextOnly';
import {
  EBaseButtonSize,
  EBaseButtonTypeAttribute,
  EButtonBorderRadiusStrength,
  EButtonTextAlign,
} from '@spinwise/react-component-library/ButtonAbstract';

export interface ICustomBonusTable {
  title: string;
  description: string;
  bonus_image: string;
  table_item: any;
  is_button_shown?: boolean;
  btn_text?: string;
  authorized_btn_text?: string;
  btn_url?: string;
  authorized_btn_url?: string;
}
const CustomBonusTable = (props: ICustomBonusTable) => {
  const dispatch = useDispatch();
  const loggedIn = useSelector((state: IApplicationState) => state.authReducer.auth?.success);

  const openTerms = (slug: string) => {
    dispatch({
      type: OVERLAY_CMS_PAGE_SHOW,
      data: {
        show: true,
        data: {
          slug: slug,
          position: POSITIONS.TOP,
          contentWidth: EOverlayContentWidth.LARGE,
        },
      },
    });
  };

  const onButtonClick = () => {
    if (loggedIn && props?.authorized_btn_url) {
      dispatch({
        type: OVERLAY_ALL_CLOSE,
        data: true,
      });
      router.push(props?.authorized_btn_url);

      return;
    } else {
      dispatch({
        type: OVERLAY_ALL_CLOSE,
        data: true,
      });
      router.push(props?.btn_url);

      return;
    }
  };

  return (
    <>
      <div className={classNames(styles.custom_bonus_table)}>
        <div className={styles.table_container}>
          <div className={`d-fl jc-fs ai-c`}>
            <div className={styles.table_container__big}>
              <div className={styles.table_container__icon}>
                <BrandIcon
                  iconSize={BrandIconsSizes.Small}
                  iconPath={BonusIconMap?.[props?.bonus_image]}
                  statusPath={StatusIcons.None}
                  shapeColor={ShapeColors.Default}
                />
              </div>
              <div className={classNames(styles.table_container__text, 'd-fl fl-d-c jc-c ai-c')}>
                <BaseText value={props?.title} size={EBaseTextSize.Regular} color={EBrandTextColor.Black} />
                <div className={styles.table_container__text__description}>{props?.description}</div>
              </div>
              {props?.is_button_shown && (
                <div className={classNames(styles.button_container, EComponentVisibility.TableteDesktop)}>
                  <div className={styles.button_container}>
                    <ButtonTextOnly
                      label={
                        loggedIn && props?.authorized_btn_text
                          ? props?.authorized_btn_text
                          : !loggedIn && props?.btn_text
                          ? props?.btn_text
                          : t('read.more.btn')
                      }
                      size={EBaseButtonSize.Medium}
                      textSize={EBaseTextSize.Small}
                      type={ButtonLibrary.Bonuses}
                      borderRadius={EButtonBorderRadiusStrength.Seven}
                      typeAttribute={EBaseButtonTypeAttribute.Submit}
                      fullWidth={true}
                      alignText={EButtonTextAlign.Center}
                      onClick={() => onButtonClick()}
                    ></ButtonTextOnly>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={`d-fl jc-fs ai-c fl-d-c`}>
            <div className={styles.custom_bonus_table__open}>
              {props?.table_item?.map((item, i) => {
                if (item?.terms?.data?.attributes) {
                  return (
                    <PromoTableItem
                      key={item.title}
                      text={item?.title}
                      bonusValue={
                        <div
                          className={styles.bonus_terms}
                          onClick={() => openTerms(item?.terms?.data?.attributes?.slug)}
                        >
                          <BaseText
                            value={item?.terms?.data?.attributes?.title}
                            color={TypographyLibrary.Base}
                            weight={EBaseTextWeight.W400}
                          ></BaseText>
                        </div>
                      }
                    ></PromoTableItem>
                  );
                } else {
                  return (
                    <PromoTableItem key={item.title} text={item?.title} bonusValue={item?.bonus_value}></PromoTableItem>
                  );
                }
              })}
            </div>
            {props?.is_button_shown && (
              <div className={classNames('d-fl jc-fs ai-c', styles.button_container, EComponentVisibility.MobileOnly)}>
                <ButtonTextOnly
                  label={
                    loggedIn && props?.authorized_btn_text
                      ? props?.authorized_btn_text
                      : !loggedIn && props?.btn_text
                      ? props?.btn_text
                      : t('read.more.btn')
                  }
                  size={EBaseButtonSize.Medium}
                  type={ButtonLibrary.Bonuses}
                  borderRadius={EButtonBorderRadiusStrength.Seven}
                  typeAttribute={EBaseButtonTypeAttribute.Submit}
                  fullWidth={true}
                  alignText={EButtonTextAlign.Center}
                  onClick={() => onButtonClick()}
                ></ButtonTextOnly>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomBonusTable;
